module.exports = __webpack_public_path__ + "img/pic_popup_startedlogin1@3x.ffedccff.png";